import { toast } from 'react-toastify';
import moment from 'moment';

var timeout = [];

// Determines if a sequence in sequencesData is currently selected
export function findSelectedSequence(state) {
  const sequencesData = state.sequencesData;
  const foundSequence = sequencesData.find((sequence) => {
    return sequence.sequence_id === state.selectedSequence.sequence_id;
  });
  return foundSequence;
}

// find popups for the current sequence step
export function findSelectedSequencePopups(state, currentSeqItemId) {
  if (!state.sequence.selectedSequence) return null;
  const date = (state.date.selectedDate instanceof Date)? state.date.selectedDate : new Date(state.date.selectedDate);
  const sequenceSteps = state.sequence.selectedSequence.sequence_steps;
  const foundSequenceStep = sequenceSteps.find((seqStep) => {
    return seqStep.sequence_item_id === currentSeqItemId;
  });
  const popups = foundSequenceStep.sequence_step_to_popup.filter(popup => {
    const isActive = (moment(popup.active_start).valueOf() <= moment().valueOf())
      && (moment().valueOf() <= moment(popup.active_end).valueOf());
    const activeDay = (popup.active_days.find(day => {
      return day === date.getDay();
    })) !== undefined;
    return isActive && activeDay;
  });
  return popups;
}

// notify the current screen with all of the popups
export function notify(popups) {
  let nextDuration = 0;
  if (popups) {
    for (let i = 0; i < popups.length; i++) {
      const pop = popups[i];

      timeout[i] = setTimeout(() => {
        toast(pop.content, {
          autoClose: pop.display_duration === -1 ? false : pop.display_duration * 100,
          hideProgressBar: pop.display_duration === -1
        });
      }, (pop.display_delay + nextDuration) * 100);

      if (pop.display_duration === -1) break;
      nextDuration += pop.display_duration + pop.display_delay;
    }
  }
}

export function stopNotify() {
  for (let i = 0; i < timeout.length; i++) {
    clearTimeout(timeout[i]);
  }
}
